/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
import React, { useState, useEffect, useMemo } from 'react';
import { isFloat } from 'validator';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import {
  InputAdornment,
  Button,
  Box,
  TextField,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import * as actions from '../../store/modules/auth/actions';
import axios from '../../services/axios';
import { ContainerGrid, Title, SubTitle } from '../../styles/GlobalStyles';
import DataTableView from '../../components/DataTableView';
import DataTableViewNoAction from '../../components/DataTableViewNoAction';
import Loading from '../../components/Loading';
import NumberFormatCustom from '../../utils/NumberFormatCustom';
import NumberFormatCustom3 from '../../utils/NumberFormatCustom3';
import NumberFormatKm from '../../utils/NumberFormatKm';

dayjs.locale('pt-br');

export default function ControleViagensMotorista() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [saida, setSaida] = useState(dayjs());
  const [retorno, setRetorno] = useState(dayjs());
  const [imgsaida, setImgSaida] = useState('');
  const [imgretorno, setImgRetorno] = useState('');
  const [kmsaida, setKmSaida] = useState('');
  const [kmretorno, setKmRetorno] = useState('');
  const [veiculo, setVeiculo] = useState('');
  const [despesas, setDespesas] = useState([]);
  const [receitas, setReceitas] = useState([]);
  const [consumo, setConsumo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // Estados para controlar a visibilidade dos modais
  const [isModalSaidaOpen, setIsModalSaidaOpen] = useState(false);
  const [isModalRetornoOpen, setIsModalRetornoOpen] = useState(false);
  const [tempSaida, setTempSaida] = useState(saida);
  const [tempKmSaida, setTempKmSaida] = useState(kmsaida);
  const [tempImgSaida, setTempImgSaida] = useState(imgsaida);
  const [tempRetorno, setTempRetorno] = useState(retorno);
  const [tempKmRetorno, setTempKmRetorno] = useState(kmretorno);
  const [tempImgRetorno, setTempImgRetorno] = useState(imgretorno);

  const [totaladiantamentos, setTotalAdiantamentos] = useState('');
  const [totalcomissao, setTotalComissao] = useState('');
  const [saldoareceber, setSaldoAReceber] = useState('');
  const [mediaConsumo, setMediaConsumo] = useState('');
  const [totaldespesasMotorista, setTotalDespesasMotorista] = useState('');

  const somaDespesasMotorista = (des) =>
    des.reduce((soma, d) => {
      if (d.TipoDespesa.flag_motorista) {
        return soma + d.valor;
      }
      return soma;
    }, 0);

  const loadDespesas = async () => {
    try {
      const { data } = await axios.get(`/viagens/${id}`);
      setDespesas(data.Despesas || [0]);
    } catch (error) {
      toast.error('Erro ao carregar despesas.');
    }
  };

  useEffect(() => {
    if (!id) return;
    loadDespesas();
  }, [id]);

  useEffect(() => {
    // Atualizar os totais de despesas com base nas despesas
    if (despesas.length > 0) {
      setTotalDespesasMotorista(somaDespesasMotorista(despesas));
    } else {
      setTotalDespesasMotorista(0);
    }

    // Calcular automaticamente a comissão
    const calculo =
      parseFloat(totalcomissao || 0) +
      parseFloat(totaldespesasMotorista || 0) -
      parseFloat(totaladiantamentos || 0);
    if (!Number.isNaN(calculo)) {
      setSaldoAReceber(calculo);
    } else {
      setSaldoAReceber('1');
    }

    // Calcular a média de consumo
    const media = (kmretorno - kmsaida) / consumo;
    if (media) setMediaConsumo(media);
  }, [
    despesas,
    totaladiantamentos,
    totalcomissao,
    totaldespesasMotorista,
    consumo,
    kmsaida,
    kmretorno,
  ]);

  async function getData() {
    try {
      setIsLoading(true);
      const { data } = await axios.get(`/viagens/${id}`);

      let children = get(data, 'Despesas', '');
      setDespesas(children);

      children = get(data, 'Receita', '');
      setReceitas(children);

      children = get(data, 'Veiculo.placa', '');
      setVeiculo(children);

      setSaida(dayjs(data.saida));
      setRetorno(dayjs(data.retorno));
      setKmSaida(data.kmsaida);
      setKmRetorno(data.kmretorno);
      setConsumo(data.consumo);

      if (
        data.imgsaida &&
        typeof data.imgsaida === 'string' &&
        data.imgsaida.length > 50
      ) {
        setImgSaida(data.imgsaida);
      } else {
        setImgSaida(null);
      }
      if (
        data.imgretorno &&
        typeof data.imgretorno === 'string' &&
        data.imgretorno.length > 50
      ) {
        setImgRetorno(data.imgretorno);
      } else {
        setImgRetorno(null);
      }
      setTotalAdiantamentos(data.totaladiantamentos || 0);
      setTotalComissao(data.totalcomissao || 0);

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate('/viagens');
    }
  }

  useEffect(() => {
    if (!id) return;
    getData();
  }, []);

  const columnsD = useMemo(
    () => [
      {
        accessorKey: 'id', // access nested data with dot notation
        header: 'ID',
        size: 80,
        hidden: true,
      },
      {
        accessorKey: 'flag_checked',
        header: 'Conferido',
        accessorFn: (row) => (get(row, 'flag_checked', 0) ? 'Sim' : 'Não'),
        size: 80,
        Cell: ({ cell }) => {
          const value = cell.getValue(); // 'Sim' ou 'Não'
          const color = value === 'Sim' ? 'green' : 'red'; // Define a cor da fonte
          return (
            <div
              style={{
                color,
                textAlign: 'center', // Centraliza o texto horizontalmente
                display: 'flex',
                justifyContent: 'center', // Centraliza o texto horizontalmente dentro do div
                alignItems: 'center', // Centraliza verticalmente se a célula for alta
                height: '100%', // Garante que o texto esteja centralizado verticalmente
              }}
            >
              {value}
            </div>
          );
        },
      },
      {
        accessorKey: 'TipoDespesa.nome',
        header: 'Tipo Despesa',
        size: 80,
      },
      {
        accessorKey: 'valor',
        accessorFn: (row) =>
          row.valor ? (
            <NumberFormatCustom value={row.valor} displayType="text" />
          ) : (
            ''
          ),
        muiTableHeadCellProps: { sx: { textAlign: 'right' } },
        header: 'Valor',
        size: 80,
      },
    ],
    []
  );

  const columnsR = useMemo(
    () => [
      {
        accessorKey: 'id', // access nested data with dot notation
        header: 'ID',
        size: 80,
        hidden: true,
      },
      {
        accessorKey: 'descricao',
        header: 'Ordem Coleta',
        size: 80,
      },
      {
        accessorKey: 'valor',
        accessorFn: (row) =>
          row.valor ? (
            <NumberFormatCustom value={row.valor} displayType="text" />
          ) : (
            ''
          ),
        muiTableHeadCellProps: { sx: { textAlign: 'right' } },
        header: 'Valor',
        size: 80,
      },
      {
        accessorKey: 'comissao',
        accessorFn: (row) =>
          row.comissao ? (
            <NumberFormatCustom value={row.comissao} displayType="text" />
          ) : (
            ''
          ),
        muiTableHeadCellProps: { sx: { textAlign: 'right' } },
        muiTableBodyCellProps: { sx: { textAlign: 'right' } },
        header: 'Comissão',
        size: 80,
      },
      {
        accessorKey: 'LocalSaida.municipio',
        header: 'Local Saída',
        size: 80,
      },
      {
        accessorKey: 'LocalDestino.municipio',
        header: 'Local Destino',
        size: 80,
      },
    ],
    []
  );

  const handleOpenModalRetorno = () => {
    setTempRetorno(retorno > 0 ? retorno : dayjs());
    setTempKmRetorno(kmretorno);
    setTempImgRetorno(imgretorno);
    setIsModalRetornoOpen(true);
  };

  const handleOpenModalSaida = () => {
    setTempSaida(saida > 0 ? saida : dayjs());
    setTempKmSaida(kmsaida);
    setTempImgSaida(imgsaida);
    setIsModalSaidaOpen(true);
  };

  const handleCloseModalSaida = () => {
    setIsModalSaidaOpen(false);
  };

  const handleCloseModalRetorno = () => {
    setIsModalRetornoOpen(false);
  };

  const handleUpdate = async (data, type) => {
    if (!id) return;

    try {
      setIsLoading(true);

      // Verifica se a imagem precisa ser enviada
      const formData = new FormData();
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in data) {
        formData.append(key, data[key]);
      }

      // Envia os dados com o cabeçalho correto
      await axios.put(`/viagens/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      toast.success(`${type} alterado(a) com sucesso!`);
    } catch (err) {
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      else toast.error('Erro ao salvar alterações');

      if (status === 401) dispatch(actions.loginFailure());
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveModalSaida = async () => {
    if (!tempSaida) {
      toast.error('Data saída inválido');
      return;
    }

    if (tempSaida.isAfter(retorno)) {
      toast.error('Data de saida não pode ser posterior à data de retorno.');
      return;
    }

    if (!isFloat(String(tempKmSaida)) || !tempKmSaida) {
      toast.error(`Valor Km Saída inválido`);
      return;
    }

    if (
      parseFloat(kmretorno) > 0 &&
      parseFloat(kmretorno) < parseFloat(tempKmSaida)
    ) {
      toast.error('Km de saida não pode ser superior ao Km de retorno.');
      return;
    }

    /* if (!tempImgSaida) {
      toast.error('Imagem do hodômetro de saída inválida');
      return;
    } */

    // Atualiza os estados principais com os temporários
    setSaida(tempSaida);
    setKmSaida(tempKmSaida);
    setImgSaida(tempImgSaida);

    // Prepara os dados para o envio
    const updateData = {
      saida: tempSaida.format(), // Formata a data para string, se necessário
      kmsaida: tempKmSaida,
      imgsaida: tempImgSaida,
    };

    // Chama a função de atualização
    await handleUpdate(updateData, 'Saída');
    handleCloseModalSaida();
  };

  const handleSaveModalRetorno = async () => {
    if (!tempRetorno) {
      toast.error('Data retorno inválido');
      return;
    }

    if (tempRetorno.isBefore(saida)) {
      toast.error('Data de retorno não pode ser anterior à data de saída.');
      return;
    }

    if (!isFloat(String(tempKmRetorno)) || !tempKmRetorno) {
      toast.error(`Valor Km Retorno inválido`);
      return;
    }

    if (parseFloat(tempKmRetorno) < parseFloat(kmsaida)) {
      toast.error('Km de retorno não pode ser inferior ao Km de saída.');
      return;
    }

    /* if (!tempImgRetorno) {
      toast.error('Imagem do hodômetro de retorno inválido');
      return;
    } */
    // Atualiza os estados principais com os temporários
    setRetorno(tempRetorno);
    setKmRetorno(tempKmRetorno);
    setImgRetorno(tempImgRetorno);

    // Prepara os dados para o envio
    const updateData = {
      retorno: tempRetorno.format(), // Formata a data para string, se necessário
      kmretorno: tempKmRetorno,
      imgretorno: tempImgRetorno,
    };

    // Chama a função de atualização
    await handleUpdate(updateData, 'Retorno');
    handleCloseModalRetorno();
  };

  return (
    <ContainerGrid>
      <Loading isLoading={isLoading} />
      <Title>
        {id
          ? `Motorista - Viagem Nr. ${id}`
          : 'Registro de Viagem não Localizado'}
      </Title>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '10px',
        }}
      >
        <Button
          type="button"
          color="primary"
          variant="contained"
          style={{ marginRight: '5px', height: '60px', width: '131px' }}
          onClick={handleOpenModalSaida}
        >
          Km Saída
        </Button>
        <Button
          type="button"
          color="primary"
          variant="contained"
          style={{ height: '60px', width: '131px' }}
          onClick={handleOpenModalRetorno}
        >
          Km Retorno
        </Button>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          style={{ marginRight: '5px', height: '60px', width: '100px' }}
          onClick={() => navigate(-1)}
          // onClick={() => navigate(`/Viagemmotorista`)}
        >
          Fechar
        </Button>
      </Box>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                readOnly
                label="Data Saída"
                variant="filled"
                size="small"
                value={saida}
                format="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                readOnly
                label="Data Retorno"
                variant="filled"
                size="small"
                value={retorno}
                format="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12} sm={4}>
            <TextField
              value={kmsaida}
              label="Km Saída"
              InputProps={{
                inputComponent: NumberFormatKm,
                startAdornment: (
                  <InputAdornment position="start">Km</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              value={kmretorno}
              label="Km Retorno"
              InputProps={{
                inputComponent: NumberFormatKm,
                startAdornment: (
                  <InputAdornment position="start">Km</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              value={mediaConsumo}
              label="Consumo Médio"
              InputProps={{
                inputComponent: NumberFormatCustom3,
                startAdornment: (
                  <InputAdornment position="start">Km/L</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
        </Grid>
      </Box>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          border: '1px solid black',
          '& .MuiTextField-root': {
            m: 1,
            width: { xs: '85%', sm: '85%' },
          },
        }}
      >
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12} sm={3}>
            <TextField
              value={totalcomissao}
              label="Total Comissao"
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              value={totaldespesasMotorista}
              label="Despesas Pagas Motorista"
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              value={totaladiantamentos}
              label="Total Adiantamento"
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              value={saldoareceber}
              label="Saldo a Receber"
              InputProps={{
                inputComponent: NumberFormatCustom,
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
                readOnly: true,
              }}
              variant="filled"
              size="small"
            />
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={1} justifyContent="center">
        <Grid item xs={12} sm={6}>
          <SubTitle>Despesas</SubTitle>
          <Button
            type="button"
            color="secondary"
            variant="contained"
            onClick={() => navigate(`/despesa/${id}`)}
          >
            Nova Despesa
          </Button>
          <div>
            <DataTableView
              columns={columnsD}
              data={despesas}
              tableData="despesas"
              tableRoute={`despesa/${id}`}
              tableRoute2="despesa"
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={6}>
          <SubTitle>Receitas</SubTitle>
          <div>
            <DataTableViewNoAction columns={columnsR} data={receitas} />
          </div>
        </Grid>
      </Grid>
      <ModalSaida
        isOpen={isModalSaidaOpen}
        onClose={handleCloseModalSaida}
        onSave={handleSaveModalSaida}
        tempSaida={tempSaida}
        setTempSaida={setTempSaida}
        tempKmSaida={tempKmSaida}
        setTempKmSaida={setTempKmSaida}
        placa={veiculo}
        tempImgSaida={tempImgSaida}
        setTempImgSaida={setTempImgSaida}
      />
      <ModalRetorno
        isOpen={isModalRetornoOpen}
        onClose={handleCloseModalRetorno}
        onSave={handleSaveModalRetorno}
        tempRetorno={tempRetorno}
        setTempRetorno={setTempRetorno}
        tempKmRetorno={tempKmRetorno}
        setTempKmRetorno={setTempKmRetorno}
        tempImgRetorno={tempImgRetorno}
        setTempImgRetorno={setTempImgRetorno}
      />
    </ContainerGrid>
  );
}

function ModalSaida({
  isOpen,
  onClose,
  onSave,
  tempSaida,
  setTempSaida,
  tempKmSaida,
  setTempKmSaida,
  placa,
  tempImgSaida,
  setTempImgSaida,
}) {
  const processFile = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const maxWidth = 800;
        const scale = maxWidth / img.width;
        const newWidth = maxWidth;
        const newHeight = img.height * scale;

        const canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        ctx.canvas.toBlob(
          (blob) => {
            const newFile = new File([blob], file.name, {
              type: 'image/jpeg',
              lastModified: Date.now(),
            });
            setTempImgSaida(newFile); // Armazena diretamente no tempImgSaida
          },
          'image/jpeg',
          0.75
        );
      };
    };
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    const fetchUltimoKmRetorno = async () => {
      if (isOpen && placa) {
        try {
          const response = await axios.get(`/viagens/ultimo-km/${placa}`);
          const { kmRetorno } = response.data;
          setTempKmSaida(kmRetorno || 0);
        } catch (error) {
          toast.error('Erro ao carregar última Quilometragem.');
        }
      }
    };

    fetchUltimoKmRetorno();
  }, [isOpen, placa, setTempKmSaida]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      processFile(file);
    }
  };

  const handleRemoveImage = () => {
    setTempImgSaida(null); // Reseta diretamente tempImgSaida
  };

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Informações de Km Saída</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            marginTop: '15px',
          }}
        >
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="pt-br"
          >
            <DatePicker
              required
              id="tempSaida"
              label="Data Saída"
              size="small"
              value={tempSaida}
              onChange={setTempSaida}
              renderInput={(params) => <TextField {...params} required />}
              format="DD/MM/YYYY"
            />
          </LocalizationProvider>
          <TextField
            required
            id="tempKmSaida"
            value={tempKmSaida}
            onChange={(e) => setTempKmSaida(e.target.value)}
            label="Km Saída"
            size="small"
            InputProps={{
              inputComponent: NumberFormatKm,
              startAdornment: (
                <InputAdornment position="start">Km</InputAdornment>
              ),
            }}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              alignItems: 'center',
            }}
          >
            {tempImgSaida ? (
              <>
                <img
                  src={
                    tempImgSaida instanceof File
                      ? URL.createObjectURL(tempImgSaida)
                      : tempImgSaida
                  }
                  alt="Imagem selecionada"
                  style={{ maxWidth: '100%', height: 'auto' }}
                />
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleRemoveImage}
                >
                  Remover Imagem
                </Button>
              </>
            ) : (
              <>
                <Button variant="contained" component="label">
                  Adicionar imagem do hodômetro de saída
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </Button>
                <p>Nenhuma imagem selecionada</p>
              </>
            )}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={onSave}>Salvar</Button>
      </DialogActions>
    </Dialog>
  );
}

function ModalRetorno({
  isOpen,
  onClose,
  onSave,
  tempRetorno,
  setTempRetorno,
  tempKmRetorno,
  setTempKmRetorno,
  tempImgRetorno,
  setTempImgRetorno,
}) {
  const processFile = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const maxWidth = 800;
        const scale = maxWidth / img.width;
        const newWidth = maxWidth;
        const newHeight = img.height * scale;

        const canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        ctx.canvas.toBlob(
          (blob) => {
            const newFile = new File([blob], file.name, {
              type: 'image/jpeg',
              lastModified: Date.now(),
            });
            setTempImgRetorno(newFile); // Atualiza diretamente o estado tempImgRetorno
          },
          'image/jpeg',
          0.75
        );
      };
    };
    reader.readAsDataURL(file);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      processFile(file);
    }
  };

  const handleRemoveImage = () => {
    setTempImgRetorno(null); // Reseta a imagem selecionada
  };

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Informações de Km Retorno</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column', // Alinha itens verticalmente
            gap: 2, // Espaçamento entre os itens
            marginTop: '15px',
          }}
        >
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="pt-br"
          >
            <DatePicker
              id="tempRetorno"
              label="Data Retorno"
              size="small"
              value={tempRetorno}
              onChange={setTempRetorno}
              renderInput={(params) => <TextField {...params} required />}
              format="DD/MM/YYYY"
            />
          </LocalizationProvider>
          <TextField
            required
            id="tempKmRetorno"
            value={tempKmRetorno}
            onChange={(e) => setTempKmRetorno(e.target.value)}
            label="Km Retorno"
            size="small"
            InputProps={{
              inputComponent: NumberFormatKm,
              startAdornment: (
                <InputAdornment position="start">Km</InputAdornment>
              ),
            }}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              alignItems: 'center',
            }}
          >
            {tempImgRetorno ? (
              <>
                <img
                  src={
                    tempImgRetorno instanceof File
                      ? URL.createObjectURL(tempImgRetorno)
                      : tempImgRetorno
                  }
                  alt="Imagem selecionada"
                  style={{ maxWidth: '100%', height: 'auto' }}
                />
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleRemoveImage}
                >
                  Remover Imagem
                </Button>
              </>
            ) : (
              <>
                <Button variant="contained" component="label">
                  Adicionar imagem do hodômetro de Retorno
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </Button>
                <p>Nenhuma imagem selecionada</p>
              </>
            )}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={onSave}>Salvar</Button>
      </DialogActions>
    </Dialog>
  );
}
